import { useAppDispatch, useAppSelector } from "../../../../../app/hooks";
import {
  FlashCallConfirmation,
  SmsConfirmation,
  UserCallConfirmation,
} from "./ConfirmationWays";
import React, { useCallback, useEffect } from "react";
import { Popup } from "../../../../../ui/Modal/Popup";
import styled from "styled-components";
import {useTranslation} from "react-i18next";
import {PhoneConfirmationWay} from "../../../../../enum/phoneConfirm";
import {Body1PointerLink} from "../../../../../components/Font";
import {ContentTop16} from "../../../../../components/ui/Content";
import {cleanError} from "../../../slice";
import { LoaderEnum, MiniLoader } from "../../../../../ui/Loader/MiniLoader";
import { useTheme } from "styled-components";

interface ISelectedWayProps {
  onChangeWay(): void;
  onClose(): void;
}

export const SelectedConfirmationWay = ({onChangeWay, onClose}: ISelectedWayProps) => {
    const confirmNumberModalLoader = useAppSelector((state) => state.phoneConfirm.confirmNumberModalLoader);
    const {selectedWay} = useAppSelector(state => state.phoneConfirm)
    const {error} = useAppSelector(state => state.auth)
    const ways = useAppSelector((state) => state.phoneConfirm.ways);
    const {t} = useTranslation()
    const Theme = useTheme()
    const dispatch = useAppDispatch()

  const Content = useCallback(() => {
    switch (selectedWay) {
      case PhoneConfirmationWay.sms:
        return <SmsConfirmation />;
      case PhoneConfirmationWay.userCall:
        return <UserCallConfirmation />;
      case PhoneConfirmationWay.flashCall:
        return <FlashCallConfirmation />;
      default:
        return null;
    }
  }, [selectedWay]);

  useEffect(() => {
    if (error["code"]) {
      dispatch(cleanError("code"));
    }
  }, [selectedWay]);

    return (
      <Popup
      className="radius"
        style={{
            padding: 0,
            width: 410,
            height: 'fit-content',
        }}
        onClose={onClose}
        opened={true}
        title={t('passport.registrationForm.callbackAlert.title')}
      >
        <PopupBody>
        {confirmNumberModalLoader ?
          <CenterBlock>
            <MiniLoader color={Theme.color.primary} size={LoaderEnum.small}/>
          </CenterBlock> : <Content />}
        {ways.length > 1 &&
            <ContentTop16>
                <Body1PointerLink onClick={onChangeWay}>
                    {t('passport.registrationForm.phoneConfirm.changeWay')}
                </Body1PointerLink>
            </ContentTop16>}
        </PopupBody>
    </Popup>
  );
};

const PopupBody = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 24px 24px;
`
const CenterBlock = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 56px 0 56px 0;
`;
